import { useState } from 'react';
import { readableEvidence } from '../utils/supportingEvidence';

export function broadEvidence(value) {
  return value.length > 1600 || value.trim().split(/(?<=[.!?])\s+(?=[A-Z“"[])/).length > 5;
}
function SourceContext({ value, label = 'Show source context' }) {
  const [expanded, setExpanded] = useState(false);
  return <details onToggle={event => setExpanded(event.currentTarget.open)}>
    <summary>{label} ({value.length.toLocaleString()} characters)</summary>
    {expanded && <blockquote>{readableEvidence(value)}</blockquote>}
  </details>;
}
export default function EvidenceDisplay({ record, provenance, sourceFile }) {
  if (!record.evidence && !record.source_fragment) return null;
  const evidence = record.evidence || '';
  const broad = broadEvidence(evidence) && !record.evidence_necessity;
  const file = record.source_file || sourceFile || record.paper_id;
  const visual = ['figure_numeric', 'curve_interpretation', 'figure_visual'].includes(record.evidence_basis) || record.source_fragment?.mode === 'visual';
  const source = provenance?.paper_sources?.[file] || provenance?.paper_sources?.[file?.replace(/^\d+_/, '')];
  const rawPage = record.source_fragment?.physical_page || record.page_num;
  const page = /^\d+$/.test(String(rawPage)) && Number(rawPage) > 0 ? Number(rawPage) : null;
  const regionBase = Number.isSafeInteger(source?.id) ? `${process.env.REACT_APP_API_BASE_URL || '/api'}/upload/papers/${source.id}/evidence-region/` : null;
  const table = record.evidence_basis === 'table';
  const bbox = record.source_fragment?.bbox;
  const hasRegion = Array.isArray(bbox) && bbox.length === 4 && bbox.every(Number.isFinite) && bbox[0] < bbox[2] && bbox[1] < bbox[3];
  const regionUrl = regionBase && page && hasRegion ? `${regionBase}?page=${page}&bbox=${bbox.join(',')}` : null;
  if (table || visual) return <div className="edge-evidence">
    <strong>{table ? 'Table evidence' : 'PDF visual evidence'}</strong>
    <p>Source: original PDF{page ? `, page ${page}` : ''}{record.evidence_location ? ` · ${record.evidence_location}` : ''}</p>
    {regionUrl && <p><a href={regionUrl} target="_blank" rel="noopener noreferrer">{table ? 'View table region' : 'View source region'}</a></p>}
  </div>;
  return <div className="edge-evidence">
    <strong>{broad ? 'Source context' : 'Original evidence'}</strong>
    {broad ? <>
      <p className="evidence-limitation">Precise excerpt unavailable. This record retains a page or longer source passage.</p>
      <SourceContext value={evidence} label="Show original source context" />
    </> : <>
      <blockquote>{readableEvidence(record.evidence)}</blockquote>
      {Number.isInteger(record.evidence_start) && <small>Source characters {record.evidence_start}–{record.evidence_end}</small>}
    </>}
    {record.evidence_necessity && <p className="evidence-limitation">Additional evidence needed: {record.evidence_necessity}</p>}
    {record.evidence_limitation && <p className="evidence-limitation">Needs review: {record.evidence_limitation}</p>}
  </div>;
}
